import Request from "../helpers/Request";
import config from "../config";

export const getBrokerData = async brokerId =>
  new Request().get(config.pathAPI + `/brokers/${brokerId}`);

export const getBrokers = async () =>
  new Request().get(config.pathAPI + `/brokers`);

export const getBrokerQuestions = async brokerId =>
  new Request().get(config.pathAPI + `/brokers/${brokerId}/questions`);

export const getAllBrokers = async () =>
  new Request().get(config.pathAPI + `/brokers/all-brokers`);

export const getTemplatesQuestions = async () =>
  new Request().get(config.pathAPI + `/brokers/question-templates`);

export const getBrokerReports = async brokerId =>
  new Request().get(config.pathAPI + `/brokers/${brokerId}/broker-reports`);

export const createNewBrokerReport = async brokerId =>
  new Request().post(config.pathAPI + `/brokers/${brokerId}/new-report`, {});

export const createNewBroker = async data =>
  new Request().post(config.pathAPI + `/brokers/new-broker`, data);

export const getAllOperators = async () =>
  new Request().get(config.pathAPI + `/brokers/all-operators`);

export const saveOperatorId = async (tripId, operatorId) =>
  new Request().put(config.pathAPI + `/brokers/${tripId}/${operatorId}/related-operator`, {});

export const submitReport = async brokerId =>
  new Request().put(config.pathAPI + `/brokers/${brokerId}/submit-report`, {});

export const saveBroker = async (brokerId, data) =>
  new Request().put(config.pathAPI + `/brokers/${brokerId}`, data);

export const createBrokerBroker = async data =>
  new Request().post(config.pathAPI + `/brokers`, data);

export const getProperties = async () =>
  new Request().get(config.pathAPI + `/brokers`);

export const getBrokerProperty = async brokerId =>
  new Request().get(config.pathAPI + `/brokers/property/${brokerId}`);

export const setProperty = async (brokerId, data) =>
  new Request().put(config.pathAPI + `/brokers/${brokerId}/setProperty`, data);

export const setCheckAnswer = async (questionId, data) =>
  new Request().put(config.pathAPI + `/brokers/check/${questionId}`, data);

export const saveAnswers = async (brokerId, step, data) =>
  new Request().put(
    config.pathAPI + `/brokers/${brokerId}/step/${step}/saveanswers`,
    data
  );

// Entries

export const getEntries = async () =>
  new Request().get(config.pathAPI + `/brokers/`);

export const addEntry = async (questionId, data) =>
  new Request().post(config.pathAPI + `/brokers/entries/${questionId}`, data);

export const selectEntry = async (answerId, data) =>
  new Request().put(config.pathAPI + `/brokers/entries/${answerId}`, data);

// Upload Handlers

export const uploadFile = async (questionId, data) =>
  new Request().post(
    config.pathAPI + `/brokers/questions/${questionId}/file`,
    data
  );

export const uploadFiles = async (questionId, data) =>
  new Request().post(
    config.pathAPI + `/brokers/${questionId}/upload-file`,
    data
  );

export const deleteFile = async fileId =>
  new Request().delete(config.pathAPI + `/brokers/questions/file/${fileId}`);

export const uploadImage = async (brokerId, data) =>
  new Request().post(config.pathAPI + `/brokers/${brokerId}/image`, data);

// Labels
export const updateChoices = async (imageid, data) =>
  new Request().post(config.pathAPI + `/brokers/images/${imageid}`, data);

export const getAnswers = async brokerId =>
  new Request().get(config.pathAPI + `/brokers/${brokerId}/answers`);

export const uploadPropertyImage = async (brokerId, data) =>
  new Request().put(
    config.pathAPI + `/brokers/property-image/${brokerId}`,
    data
  );

export const saveImageNote = async (imageId, data) =>
  new Request().put(config.pathAPI + `/brokers/images/${imageId}/notes`, data);

// Report
export const saveReportFields = async (brokerId, data) =>
  new Request().put(
    config.pathAPI + `/brokers/${brokerId}/report-fields`,
    data
  );

export const createReport = async brokerId =>
  new Request().get(config.pathAPI + `/brokers/create-report/${brokerId}`);
